<template>
  <div class="col ma-0 pa-0 s12" v-if="true">
    <div class="col s12 pa-0 valign-wrapper">
      <div class="col s7 pl-1 pb-1 pl-1 pr-1">

        <div class="pa-0">
          <input
            ref="qtd"
            class="center ma-0"
            type="number"
            v-model="quantidade"
            @wheel="$event.target.blur()"
            @input="change"
          />
        </div>
      </div>
      <div class="col s5 pa-0">
        <div class="btn-flat btn-floating" @click="$emit('onRemoveItem')">
          <i
            style="line-height: 1.7;"
            class="tooltipped material-icons secondary-color-text right"
            data-position="top"
            data-tooltip="Remover item"
          >delete</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'editar-qtd',
  props:{
    qtd: null,
  },
  data() {
    return {
      selectValue: null,
      quantidade: null,
    }
  },
  mounted() {},
  created () {
    if(this.qtd) this.selectValue = this.qtd;
    if(this.qtd) this.quantidade = this.qtd;
  },
  methods: {
    change() {
      if(this.selectValue != 'D') this.quantidade = this.selectValue;
      this.$emit('onChange', this.quantidade);

      console.log('this.selectValue', this.selectValue);
      console.log('this.quantidade', this.quantidade);
    },
  }
}
</script>

<style lang="scss" scope>

</style>





// WEBPACK FOOTER //
// EditarQtd.vue?16a92358